$(document).ready(function () {
  let skuInput = [];
  if(window.smeg && window.smeg.promotion){
    window.smeg.promotion.sku.forEach(sku => {
      skuInput.push({
        value: sku,
        name: sku
      })
    });
  }

  $( ".autocomplete-sku div input" ).selectize({
    options: skuInput,
    valueField: 'value',
    labelField: 'name',
    searchField: ['name'],
    maxItems: 1,
    render: {
      option: function(item, escape) {
        let label = item.name || item.email;
        let caption = item.name ? item.email : null;
        return '<div>' +
          '<span class="label">' + escape(label) + '</span>' +
          (caption ? '<span class="caption">' + escape(caption) + '</span>' : '') +
          '</div>';
      }
    },
  });
});